import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Building2, Home, Sparkles, Truck, HardHat, BedDouble } from 'lucide-react';
const services = [{
  label: 'Commercial Cleaning',
  path: '/commercial-cleaning',
  matchPaths: ['/commercial-cleaning', '/commercial-cleaning-quote'],
  icon: Building2
}, {
  label: 'Basic Home Cleaning',
  path: '/basic-home-cleaning',
  matchPaths: ['/basic-home-cleaning', '/basic-home-cleaning-quote'],
  icon: Home
}, {
  label: 'Spring / Deep Cleaning',
  path: '/spring-deep-cleaning',
  matchPaths: ['/spring-deep-cleaning', '/spring-deep-cleaning-quote'],
  icon: Sparkles
}, {
  label: 'Move-In / Move-Out',
  path: '/move-in-move-out-quote',
  matchPaths: ['/move-in-move-out-quote'],
  icon: Truck
}, {
  label: 'Airbnb / Short Term Rental',
  path: '/airbnb-quote',
  matchPaths: ['/airbnb-quote'],
  icon: BedDouble
}, {
  label: 'Post Renovation',
  path: '/post-renovation-quote',
  matchPaths: ['/post-renovation-quote'],
  icon: HardHat
}];
export function ServiceNav() {
  const location = useLocation();
  return <div className="w-full bg-[#f8f9fa] border-b border-gray-200 px-6 md:px-12" data-id="element-428">
      <div className="max-w-7xl mx-auto" data-id="element-429">
        <div className="flex items-center gap-1 overflow-x-auto py-2 scrollbar-hide" data-id="element-430">
          {services.map(service => {
          const isActive = service.matchPaths.some(p => location.pathname === p);
          const IconComp = service.icon;
          return <Link key={service.label} to={service.path} className={`relative flex items-center gap-2 whitespace-nowrap px-4 py-2.5 text-sm font-medium rounded-lg transition-all ${isActive ? 'bg-white text-[#1a2744] shadow-sm' : 'text-gray-500 hover:text-[#1a2744] hover:bg-white/60'}`} data-id="element-431">
                <IconComp className={`w-4 h-4 flex-shrink-0 ${isActive ? 'text-[#e91e8c]' : 'text-gray-400'}`} data-id="element-432" />
                {service.label}
                {isActive && <motion.div layoutId="service-tab-indicator" className="absolute bottom-0 left-3 right-3 h-0.5 bg-[#e91e8c] rounded-full" transition={{
              type: 'spring',
              stiffness: 400,
              damping: 30
            }} data-id="element-433" />}
              </Link>;
        })}
        </div>
      </div>
    </div>;
}